<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="content-wrapper">
      <div class="page-header">{{ $t('remark') }}</div>
      <el-container>
        <div class="remark-display editor-preview" v-html="bindRemark(hotel)"></div>
      </el-container>
      <el-row class="edit-remark">
        <el-button type="primary" @click="onGotoEditButtonClick">{{ $t('editRemark') }}</el-button>
      </el-row>
    </div>
  </ContentContainer>
</template>

<script>
import { get } from 'lodash'
import i18nMessages from '@/translations/Hotel/ManageHotel/Remark/Index.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { getHotelInfo, getHotelIndexRoute } from '@/services/hotel-service'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { STATUS } from '@/configs/constant'
import { mapState } from 'vuex'

export default {
  name: 'HotelRemark',
  mixins: [AlertViewMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    try {
      await this.getHotelInfo(this.activeHotelId)
    } catch (err) {
      this.alertError(err.message)
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  watch: {
    activeHotelId: function (val) {
      this.getHotelInfo(val)
    }
  },
  data () {
    return {
      isLoading: false,
      hotel: {
        name: '',
        isEnable: STATUS.ENABLE,
        information: {
          address: '',
          emailList: [],
          phoneList: [],
          faxList: []
        },
        emailConfiguration: {
          senderName: '',
          replyEmail: '',
          ccEmailList: [],
          bccEmailList: []
        },
        remark: ''
      }
    }
  },
  methods: {
    getHotelInfo: async function (hotelId) {
      try {
        this.isLoading = true
        this.hotel = await getHotelInfo(hotelId)
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    onGotoEditButtonClick: function () {
      this.$router.push({
        name: 'HotelRemarkEdit',
        params: {
          hotel: this.hotel
        }
      })
    },
    bindRemark: function (hotel) {
      const remark = get(hotel, 'remark', '')
      const result = remark.replace(/(?:\r\n|\r|\n)/g, '<br>')
      return result
    }
  }
}
</script>

<style scoped>
  .remark-display {
    background-color: #fdfdfd;
    color: #2c3e50;
    text-align: left;
    min-height: 60px;
    font-size: 14px;
    padding: 10px;
    width: 100%;
    border: solid 1px #e4e4e4;
    white-space: pre-line;
  }
  .edit-remark {
    margin-top: 20px;
  }
</style>
